
import moment from 'moment'
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getAllToken } from './'

const Auth = {
	isAuthenticated: () => {
		let allToken = getAllToken()
			, refreshToken = allToken.refresh_token
			, refreshTokenExpireDate = allToken.refreshTokenExpireDate

		return !!refreshToken && moment().isBefore(moment(refreshTokenExpireDate))
	},
	isIntegration: () => {
		return true
	}
}

const PrivateRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => {
		console.log("999", Auth.isAuthenticated(), props.match.url)
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			return <Redirect to='/login' />
		}

		if (Auth.isIntegration() === false && props.match.url !== "/integration") {
			return <Redirect to='/integration' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return <Redirect to='/' />
		}
	}} />
}

const PublicRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return ""
		}
	}} />
}

export default {
	PrivateRoute,
	PublicRoute,
}


// WEBPACK FOOTER //
// ./src/lib/routePermission.js